<template>
  <div class="choose-of-wheels">
    <button
      type="button"
      class="choose-of-wheels__forward-left"
      @click="toggle('fl')"
      :class="{'activeWheel': value.forwardLeft}"
    ></button>
    <button
      type="button"
      class="choose-of-wheels__forward-right"
      @click="toggle('fr')"
      :class="{'activeWheel': value.forwardRight}"
    ></button>
    <button
      type="button"
      class="choose-of-wheels__back-left"
      @click="toggle('bl')"
      :class="{'activeWheel': value.backLeft}"
    ></button>
    <button
      type="button"
      class="choose-of-wheels__back-right"
      @click="toggle('br')"
      :class="{'activeWheel': value.backRight}"
    ></button>
    <button
      type="button"
      class="choose-of-wheels__spare-left"
      @click="toggle('sl')"
      :class="{'activeWheel': value.spareLeft}"
    ></button>
    <button
      type="button"
      class="choose-of-wheels__spare-right"
      @click="toggle('sr')"
      :class="{'activeWheel': value.spareRight}"
    ></button>
  </div>

</template>

<img src="../../assets/litie.png" height="40" width="40"/>
<script>
    export default {
        props: ['value'],
        methods: {
            toggle(target) {
              let wheelCount = 0
              console.log('wheelCount',wheelCount)
              console.log('target',target)
              console.log('this.value',this.value)
              for (let x in this.value) {
                console.log('xxxx',x)
                  if (this.value[x]) wheelCount++
              }
              console.log('wheelCount',wheelCount)
              switch (target) {
                    case 'fl':
                        if(!(this.value.forwardLeft && wheelCount == 1)) this.$emit('input', {...this.value, forwardLeft: !this.value.forwardLeft});
                        break;
                    case 'fr':
                        if(!(this.value.forwardRight && wheelCount == 1)) this.$emit('input', {...this.value, forwardRight: !this.value.forwardRight});
                        break;
                    case 'bl':
                        if(!(this.value.backLeft && wheelCount == 1)) this.$emit('input', {...this.value, backLeft: !this.value.backLeft});
                        break;
                    case 'br':
                        if(!(this.value.backRight && wheelCount == 1)) this.$emit('input', {...this.value, backRight: !this.value.backRight});
                        break;
                    case 'sl':
                        if(!(this.value.spareLeft && wheelCount == 1)) this.$emit('input', {...this.value, spareLeft: !this.value.spareLeft});
                        break;
                    case 'sr':
                        if(!(this.value.spareRight && wheelCount == 1)) this.$emit('input', {...this.value, spareRight: !this.value.spareRight});
                }
            }
        }
    }
</script>

<style scoped lang="scss">
  .choose-of-wheels {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    max-width: 142px;
    background: url("../../assets/car.png") no-repeat center 5px;

    button {
      min-width: 64px;
      min-height: 64px;
      border-radius: 50%;
      border: none;
      background-color: transparent;
      background-image: url("../../assets/wheel.png");
      background-position: center;
      background-repeat: no-repeat;
      box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);

      &.activeWheel {
        box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: #ffc110;
      }
    }

    &__forward-left,
    &__forward-right {
      margin-bottom: 50px;
    }

    &__back-left,
    &__back-right {
      margin-bottom: 15px;
    }
  }
</style>
